module.exports = __webpack_public_path__ + "img/Triangle_Down.b74a9576.svg";